import { useState, useEffect, useContext } from "react";
import saveIcon from "../../assets/save-icon.svg";
import editIcon from "../../assets/edit-latest-icon.svg";
import { CaseStageContext } from "../../dashboard/cases/contexts/CaseContexts";
import { PatientServices } from "../../services/PatientServices";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
const FamilyHistoryForm = ({ data, caseStage, saveAll }) => {
  const { patientDetails } = useContext(CaseStageContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    diabetes: "NONE",
    hypertension: "NONE",
    heartDieses: "NONE",
    stroke: "NONE",
    cancer: "NONE",
    tuberculosis: "NONE",
    asthma: "NONE",
  });
  const location = useLocation();
  const familyHistoryOptions = [
    "SELF",
    "FAMILY",
    "BOTH SELF AND FAMILY",
    "NONE",
  ];
  const handleUpdate = async () => {
    setIsSubmitting(true);
    console.log("formData from update:", formData);
    const data = { ...formData, cancers: formData?.cancer };
    try {
      await PatientServices.updateFamilyHistory(
        data,
        patientDetails?.familyhistories[0]?.id,
      );
      toast.success("Family History Data Saved");
      setIsEditMode(false);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsSubmitting(false);
  };

  useEffect(() => {
    if (!patientDetails) return;
    const data = patientDetails?.familyhistories[0];
    setFormData({
      diabetes: data?.diabetes || "NONE",
      hypertension: data?.hypertension || "NONE",
      heartDieses: data?.heartDieses || "NONE",
      stroke: data?.stroke || "NONE",
      cancer: data?.cancers || "NONE",
      tuberculosis: data?.tuberculosis || "NONE",
      asthma: data?.asthma || "NONE",
    });
  }, [patientDetails]);
  useEffect(() => {
    if (saveAll && isEditMode) {
      handleUpdate();
    }
  }, [saveAll]);
  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      <div className="grid grid-cols-3 2xl:grid-cols-4 gap-[6px] 2xl:gap-[4px] 3xl:gap-3 pt-[30px]">
        {/* Diabetes */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.diabetes}
            onChange={(e) => {
              console.log("event:", e);
              setFormData((prev) => ({
                ...prev,
                diabetes: e.target.value,
              }));
            }}
            className="absolute inset-0 w-full h-full pl-[32px] pr-[120px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Diabetes*
            </option>

            {familyHistoryOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {formData.diabetes && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Diabetes
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Hypertension */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.hypertension}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                hypertension: e.target.value,
              }))
            }
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Hypertension*
            </option>

            {familyHistoryOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {formData.hypertension && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Hypertension
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Heart Disease */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.heartDieses}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                heartDieses: e.target.value,
              }))
            }
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Heart Disease*
            </option>

            {familyHistoryOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {formData.heartDieses && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Heart Disease
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Stroke */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.stroke}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                stroke: e.target.value,
              }))
            }
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Stroke*
            </option>

            {familyHistoryOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {formData.stroke && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Stroke
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Cancer */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.cancer}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                cancer: e.target.value,
              }))
            }
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Cancer*
            </option>

            {familyHistoryOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {formData.cancer && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Cancer
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Tuberculosis */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.tuberculosis}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                tuberculosis: e.target.value,
              }))
            }
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Tuberculosis*
            </option>

            {familyHistoryOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {formData.tuberculosis && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Tuberculosis
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Asthma */}
        <div className="relative w-full h-[90px]  xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            disabled={!isEditMode}
            value={formData.asthma}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                asthma: e.target.value,
              }))
            }
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
          >
            <option value="" disabled hidden>
              Asthma*
            </option>

            {familyHistoryOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {formData.asthma && (
            <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Asthma
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      {!location?.pathname?.toLowerCase()?.includes("editcases") && (
        <div>
          {isEditMode ? (
            <div className="flex justify-end mt-[12px]">
              <button
                className="w-[170px] h-[74px] xl:w-[94.97px] xl:h-[40.97px] 2xl:w-[94.97px] 2xl:h-[40.97px] border border-none rounded-full bg-black flex justify-center items-center gap-[8px] font-lufga text-[14px] text-[#68FF9F] font-normal"
                onClick={handleUpdate}
                disabled={isSubmitting}
              >
                SAVE
                <img src={saveIcon} alt="save" className="pl-[16px]" />
              </button>
            </div>
          ) : (
            <div className="flex justify-end items-center gap-[10px] mt-[12px]">
              <button className="w-[170px] h-[74px] xl:w-[101px] xl:h-[42px] 2xl:w-[101px] 2xl:h-[42px] rounded-full border border-none bg-[#5AC69F] flex justify-center items-center gap-[10px] font-lufga text-[14px] text-white font-normal">
                SAVED
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 13L9 17L19 7"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <button
                onClick={() => setIsEditMode(true)}
                className="w-[42px] h-[42px] rounded-full border border-solid border-[#5AC69F] flex justify-center items-center bg-transparent"
              >
                <img src={editIcon} alt="edit icon" width={9} height={18} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FamilyHistoryForm;
